export default __webpack_public_path__ + "static/officer-059eca756adea36682e521eae55335f4.svg";